// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h6Ji","top":"styles_top__3wwqW","left":"styles_left__10RqT","description":"styles_description__bt0Tq"};